<template>
  <section class="tab-body">
    <p class="tab-description">
      <span class="bold-font">Send Invites</span><br>
      Invite people to accept and access pass.
    </p>

    <div class="invite-section-content"
      v-if="passDetail.status !== 'Expired' && passDetail.status !== 'Deactivated'">
      <div class="text-center form-group"><br>
        <vue-tags-input
          v-model="tag"
          placeholder="john@mail.com"
          :tags="tags"
          :validation="validation"
          @tags-changed="newTags => tags = newTags" />
        <button type="button" class="btn btn-primary" @click="doSendInvite()">
          Send Invite
        </button>
        <br>
        <small v-if="errorMessage" class="form-text text-muted error-message text-center">
          {{ errorMessage }}
        </small>
        <br>
      </div>
    </div>

    <div class="text-center" v-else>
      <p v-if="passDetail.status === 'Expired'">
        This pass is already expired. You cannot send anymore.
      </p>
      <p v-else-if="passDetail.status === 'Deactivated'">
        This pass is currently deactivated. Please activate it again to use it.
      </p>
    </div>

    <div class="invite-section-subheader">
      <div class="row">
        <div class="col-md">
          <p>
            <span class="bold-font">Invitation list</span><br>
            View details of your sent invitations.
          </p>
        </div>
        <div class="col-md">
          <small>* Accepted invites: {{ acceptedInvitesCount }}</small><br>
          <small>* Pending invites: {{ pendingInvitesCount }}</small>
          <br>
        </div>
        <div class="col-md">
          <button @click="exportInvitesToPDF()" v-if="hasAccepted"
            class="btn btn-primary btn-export">
            Export Invites to PDF
          </button>
        </div>
      </div>
    </div>

    <modal v-if="showDeleteInviteModal">
      <div slot="header" class="modal-header-content">
        <button type="button" class="btn btn-x"
          @click="closeDeleteInviteModal()">x</button>
        <div class="modal-title text-center">
          <p>Delete Invite for</p>
          <h6> {{ deleteInviteEmail }} </h6>
        </div>
      </div>

      <div slot="body">
        <div class="detail-content">
          <p class="text-center" style="padding-top: 20px;">
            Do you want to delete this pass invite?
          </p>
        </div>

        <div class="detail-title-email">
          <p>Add message to email notification</p>
        </div>

        <div class="detail-title-email-content">
          <p>TEXT FIELD HERE</p>
        </div>

      </div>

      <div slot="footer">
        <button type="button" class="btn btn-approve"
          @click="deleteInvite()">Yes</button>
        <button type="button" class="btn btn-reject"
          @click="closeDeleteInviteModal()">No</button>
      </div>
    </modal>

    <invite-list-view
      :passStatus="passDetail.status"
      :invites="invites"
      :hasInvites="hasInvites"
      :deleteInvite="openDeleteInviteModal"
      :resendInvite="resendInvite" />
  </section>

</template>

<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'

import VueTagsInput from '@johmun/vue-tags-input'

import Modal from '@/components/common/Modal'

import InvitesListView from '@/components/listview/InvitesListView'

import { APIService } from '@/api/APIService'

const api = new APIService()

export default {
  components: {
    'invite-list-view': InvitesListView,
    Modal,
    VueTagsInput
  },
  props: {
    passDetail: Object,
    invitesList: Array
  },
  data() {
    return {
      deleteInviteEmail: '',
      modalTitle: '',
      errorMessage: '',
      tag: '',
      acceptedInvitesCount: 0,
      pendingInvitesCount: 0,
      hasInvites: false,
      hasAccepted: false,
      requestInProgress: false,
      showDeleteInviteModal: false,
      invites: [],
      tags: [],
      validation: [
        {
          classes: 'invalid-email',
          rule: /\S+@\S+\.\S+/,
          disableAdd: true,
        },
        {
          classes: 'no-braces',
          rule: ({ text }) => text.indexOf('{') !== -1 || text.indexOf('}') !== -1,
        }
      ],
    }
  },
  watch: {
    invitesList(newVal, oldVal) {
      this.invites = this.invitesList
      this.constructInvites()
    },
    tags(newVal, oldVal) {
      if (newVal.length === 0) this.errorMessage = ''
    },
    passDetail(newVal, oldVal) { }
  },
  mounted() {
    this.invites = this.invitesList

    this.constructInvites()
  },
  methods: {
    async addAndSendInviteEmail(emails) {
      // update invites list API call
      const updateInviteParams = {
        pass_id: this.passDetail.id,
        user_id: this.passDetail.owner_id,
        invites: emails
      }
      await api.createUpdatePassInvites(updateInviteParams)
      // end update invites list API call

      this.showToastMessage('Invite sent')
      this.checkInvites()
    },
    async resendInvite(email) {
      this.showToastMessage('Resending Invite...')
      await this.sendEmailInvite(email)
      this.showToastMessage('Invite sent')
    },
    async sendEmailInvite(userEmail){
      const passDate = `${this.passDetail.visiting_date} - ${this.passDetail.visiting_time}`
      const emailParams = {
        link_id: this.passDetail.shareable_link_id,
        company_name: this.passDetail.company_name,
        email: userEmail,
        pass_date: passDate,
        pass_reason: this.passDetail.reason_for_visit
      }

      await api.sendInviteEmail(emailParams)
    },
    async deleteInviteCall(userEmail) {
      const params = { invites: { email: userEmail } }
      await api.deleteUserFromInviteList(this.passDetail.id, params)
    },
    // non-async functions
    constructInvites() {
      this.hasInvites = this.invites.length !== 0
      this.checkInvites()
      this.sortInvites()
    },
    checkInvites() {
      this.hasAccepted = this.invites.filter(i => i.status === 'Accepted').length !== 0
      this.acceptedInvitesCount = this.invites.filter(i => i.status === 'Accepted').length
      this.pendingInvitesCount = this.invites.filter(i => i.status === 'Pending').length
    },
    sortInvites() {
      let accepted = []
      let pending = []
      this.invites.map(a => {
        if(a.status === 'Accepted') accepted.push(a)
        else if(a.status === 'Pending') pending.push(a)
      })

      const acceptedSorted = accepted.sort((a, b) => {
        return a.individual_details.full_name.localeCompare(b.individual_details.full_name)
      })
      const pendingSorted = pending.sort((a, b) => { return a.email.localeCompare(b.email) })

      this.invites = [...pendingSorted, ...acceptedSorted]
    },
    exportInvitesToPDF() {
      const filteredList = this.invites.filter(i => i.status === 'Accepted')

      let pdfName = this.passDetail.pass_name
      const doc = new jsPDF()
      doc.setFontSize(22)
      doc.text(20, 20, `List of Names for:\n${this.passDetail.pass_name}`)
      doc.setFontSize(12)
      filteredList.map((i, ix) => {
        const y = 40 + (ix * 7)
        doc.text(i.individual_details.full_name, 20, y)
      })
      doc.save('Invites-' + pdfName + '.pdf')
    },
    openDeleteInviteModal(data) {
      this.modalTitle = `Delete Invite`
      this.deleteInviteEmail = data.email
      this.modalMessage = `Delete invite for: ${data.email}`
      this.showDeleteInviteModal = true
    },
    closeDeleteInviteModal() { this.showDeleteInviteModal = false },
    doSendInvite() {
      this.errorMessage = ''

      if(this.tags.length === 0) {
        this.errorMessage = 'Please add an email'
      } else {
        if(this.passDetail.type_of_pass === 'Solo Pass' && this.invites.length === 1) {
          this.errorMessage = 'Cannot add another email since this is a Solo pass'
          return
        }
        if(this.passDetail.type_of_pass === 'Solo Pass' && this.tags.length > 1) {
          this.errorMessage = 'Cannot add another email since this is a Solo pass'
          return
        }

        this.sendInvite()
      }
    },
    sendInvite() {
      const invites = this.invites.map(i => i.email)
      const emails = this.tags.map(i => {
        return { email: i.text.toLowerCase(), status: 'Pending' }
      })

      const filteredEmails = emails.filter(function(item){
        return invites.indexOf(item.email) === -1;
      })
      this.invites.push(...filteredEmails)
      this.sortInvites()
      this.hasInvites = this.invites.length !== 0
      this.haveNewEmails = filteredEmails.length !== 0
      // reset field
      this.tags = []
      this.tag = ''
      if(filteredEmails.length === 0) {
        this.showToastMessage('Email is already in the list. ' +
          'Please click, resend email if user haven’t accepted it yet.')
      }
      else this.addAndSendInviteEmail(filteredEmails)
    },
    deleteInvite() {
      this.invites = this.invites.filter(i => { return i.email !== this.deleteInviteEmail })
      this.hasInvites = this.invites.length !== 0
      const userEmail = this.deleteInviteEmail.toLowerCase()
      this.deleteInviteCall(userEmail)
      this.closeDeleteInviteModal()
      this.checkInvites()
    },
    showToastMessage(msg) {
      this.$toasted.show(msg, {
      	theme: 'toasted-primary',
      	position: 'top-right',
      	duration : 1500
      })
    }
  }
}
</script>

<style scoped>
.btn-export {
  margin-top: -1px;
}

div.ti-input, .vue-tags-input {
  margin: auto;
  align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/tabview/InviteTab.vue